import dayjs from "dayjs";
import { FilledGreenWiteTick } from "components/icons/FilledGreenWhiteTick";
import { DISPLAY_DATE } from "constants/date";
import { ClientProgressCycle } from "types/Models/task";
import { JourneyCycleHeader } from "./JourneyCycleHeader";

type JourneyPreviousCycleProps = {
  cycle: ClientProgressCycle;
};

export const JourneyPreviousCycle = ({ cycle }: JourneyPreviousCycleProps) => {
  const headerLabel = cycle.amendment_number
    ? `Amendment ${cycle.amendment_number}`
    : "Original";
  const filedPrefix = cycle.amendment_number
    ? `Amendment ${cycle.amendment_number} filed`
    : "Filed";
  const filedLabel = cycle.filed_date
    ? `${filedPrefix} on ${dayjs(cycle.filed_date).format(DISPLAY_DATE)}`
    : filedPrefix;
  const amendedOn = dayjs(cycle.amended_date).format(DISPLAY_DATE);
  const nextAmendmentNumber = cycle.amendment_number + 1;

  return (
    <div className="t-pb-4">
      <JourneyCycleHeader label={headerLabel} />
      <div className="t-flex t-gap-2">
        <span className="t-flex-shrink-0">
          <FilledGreenWiteTick />
        </span>
        <div className="t-flex t-flex-col t-items-start t-gap-1 t-text-left">
          <span className="t-italic">{filedLabel}</span>
          <span className="t-italic">
            Amendment {nextAmendmentNumber} initiated on {amendedOn}
          </span>
        </div>
      </div>
    </div>
  );
};
